import { THEME_OPTIONS, themeState } from "@/state/Theme";
import { userState } from "@/state/Users";

export function initThemeMenu(): void {
    const buttons = new Map(
        THEME_OPTIONS.map((theme) => [
            theme,
            document.querySelector<HTMLButtonElement>(`.theme-option[data-theme="${theme}"]`),
        ]),
    );

    if ([...buttons.values()].every((button) => button === null)) {
        return;
    }

    buttons.forEach((button, theme) => {
        button?.addEventListener("click", () => {
            themeState.selectedTheme = theme;
            void userState.update({ theme });
            buttons.forEach((b, t) => b?.setAttribute("aria-pressed", String(t === theme)));
        });
    });
}
